import "./EffectKey.css";

export default function EffectKey() {
  return (
    <div className="effect-key-wrapper">
        <div className="effect-key-inner">

            <div className="effect-key-box">

                <h1 className="effect-key-title">EFFECTS KEY</h1>
                
                <hr style={{ border: '1px solid #38322b', margin: '1rem 0' }} /> {/* line thingy */}

                <ul>
                    <li><span>🧠: critical thinking</span></li>
                    <li><span>🛡️: trust in speaker</span></li>
                    <li><span>📣: amplification</span></li>
                    <li><span>⏰: urgency</span></li>
                    <li><span>🌀: mental clarity</span></li>
                    <li><span>🧩: nuance</span></li>
                    <li><span>🤔: curiosity</span></li>
                    <li><span>🫢: silencing effect</span></li>
                    <li><span>📊: fact checking</span></li>
                    <li><span>❌: blocked reasoning</span></li>
                    <li><span>💥: polarisation</span></li>
                    <li><span>🧭: moral disorientation</span></li>
                    <li><span>💢: emotional spikes</span></li>

                
                </ul>
            </div>

            <div className="effect-key-label">EFFECTS KEY</div>

        </div>
    </div>
  );
}